import React, { useState, useEffect, useRef } from 'react'
import { Form, Button } from 'react-bootstrap'
import Layout from '../Layout/Layout';
import DataTable from 'react-data-table-component';
import { APIUrl } from '../../Helper/APIUrl.js';
import { SnackbarProvider, useSnackbar } from "notistack";
import { data } from 'autoprefixer';

function CreateProperty() {
    const Token = JSON.parse(localStorage.getItem('tcn'));

    const { enqueueSnackbar } = useSnackbar();

    const [val, setVal] = useState(0);

    const [search, setsearch] = useState("");
    const [sztype, setsztype] = useState([]);
    const [filtersztype, setfiltersztype] = useState([]);

    //Use Ref for Focus
    const TypeNameInputRef = useRef(null);

    const [zsection, setzsection] = useState([]);

    //Insert and Update UseStates

    const [TypeId, setTypeId] = useState("");
    const [TypeName, setTypeName] = useState("");
    const [SectionId, setSectionId] = useState(0);
    const [SectionName, setSectionName] = useState("");

    const [IsActive, setisactive] = useState(true);
    const [CreatedBy, setCreatedBy] = useState(1);
    const [CreatedOn, setCreatedOn] = useState("");
    const [ModifiedBy, setModifiedBy] = useState(1);
    const [ModifiedOn, setModifiedOn] = useState("");

    //Edit Populates States
    const [edit, setEdit] = useState(false);
    const [returnId, setreturnId] = useState(0);

    //API : Base Url + Controller Name
    const ConcateURL = APIUrl.SZType;

    function doEmptyStates() {
        setTypeName("");
        //setSectionId("");
        setSectionName("");
        setEdit(false)
    }



    const getAllZSections = async () => {
        try {
            const response = await fetch(APIUrl.ZSections + 'GetAllZSections', {
                method: "Post",
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${Token}`
                },
                body: JSON.stringify({})
            });

            const result = await parseJSON(response);
            if (result?.data != null) {
                const filterData = result.data.filter(x => x.PropertyCategoryTag == "Category" && x.IsActive == true)
                setzsection(filterData);
            }
        }
        catch (error) {
            console.log(error);
        }
    };

    const parseJSON = async (response) => {
        try {
            if (response.status === 204 || response.status === 205) return null;
            const text = await response.text();
            if (!text) return null;
            return JSON.parse(text);
        }
        catch (err) {
            console.warn('Failed to parse JSON response', err);
            return null;
        }
    }

    const getAllsztypes = async () => {
        try {
            const response = await fetch(ConcateURL + 'GetAllSZType', {
                method: "Post",
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${Token}`
                },
                body: JSON.stringify({})
            });
            const result = await parseJSON(response);
            if (result?.data != null) {
                const filterData = result.data.filter(x => x.SectionId == 11 || x.SectionId == 12)

                setsztype(filterData.sort((a, b) => b.TypeId - a.TypeId));
                setfiltersztype(filterData.sort((a, b) => b.TypeId - a.TypeId));

            }
        }
        catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        getAllsztypes();
        getAllZSections();
    }, []);

    const insertsztypes = async () => {
        try {
            debugger
            if (SectionId === 0 || SectionId == "0") {
                enqueueSnackbar("Select Section", { variant: "warning" });
                return;
            }
            else if (TypeName.length == 0) {
                enqueueSnackbar("Enter SZType ", { variant: "warning" });
                return;
            }
            else {
                console.warn(returnId);
                let data = { TypeName, SectionId, IsActive, CreatedBy, ModifiedBy }
                const response = await fetch(ConcateURL + 'InsertSZType', {
                    method: "Post",
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${Token}`
                    },
                    body: JSON.stringify(data)
                });
                const result = await parseJSON(response);
                if (result) {
                    setreturnId(result.returnID);
                    enqueueSnackbar("Successfully Added", { variant: "success" });
                    getAllsztypes();
                    doEmptyStates();
                }
            }

        }
        catch (error) {
            console.log(error);
        }
    };

    const coloumn = [
        {
            name: "SNo.",
            selector: (row, index) => index + 1
        },
        //  {
        //     name: "Section Id",
        //     selector: (row) => row.SectionId,
        // },
        {
            name: "Property Types",
            selector: (row) => row.SectionName,
            sortable: true,
            reorder: true
        },
        // {
        //     name: "Type Id",
        //     selector: (row) => row.TypeId,
        // },
        {
            name: "Property Type Name",
            selector: (row) => row.TypeName,
            sortable: true,
            style: {
                width: '700px',
            }
        },
        {
            name: <strong>Activated/Deactivated</strong>,
            selector: (row) => row.IsActive ? <label class="inline-flex px-2 py-1 text-xs font-semibold rounded-full bg-green-100 text-green-800">Activated</label> : <label class="inline-flex px-2 py-1 text-xs font-semibold rounded-full bg-yellow-100 text-yellow-800">Deactivated</label>,
        },
        // {
        //     name: "Is Residential",
        //     cell: row =>
        //         <div>
        //             {
        //                 <>
        //                     {
        //                         !row.IsResidential
        //                             ?
        //                             <Button onClick={() => fnUpdateIsResidential(row.TypeId, "activate")} data-tip="Click to Update" className="text-white bg-gradient-to-r from-red-400 via-red-500 to-red-600 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm px-4 py-2"  ><i class="fa fa-times" aria-hidden="true"></i></Button>
        //                             :
        //                             <Button onClick={() => fnUpdateIsResidential(row.TypeId, "deactivate")} data-tip="Click to Update" className="text-white bg-gradient-to-r from-green-400 via-green-500 to-green-600 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-green-300 font-medium rounded-lg text-sm px-4 py-2"><i class="fa fa-check" aria-hidden="true"></i> </Button>
        //                     }
        //                 </>
        //             }
        //         </div>
        // },
        // {
        //     name: "Is Commercial",
        //     cell: row =>
        //         <div>
        //             {
        //                 <>
        //                     {
        //                         !row.IsCommercial
        //                             ?
        //                             <Button onClick={() => fnUpdateIsCommercial(row.TypeId, "activate")} data-tip="Click to Update" className="text-white bg-gradient-to-r from-red-400 via-red-500 to-red-600 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm px-4 py-2"  ><i class="fa fa-times" aria-hidden="true"></i></Button>
        //                             :
        //                             <Button onClick={() => fnUpdateIsCommercial(row.TypeId, "deactivate")} data-tip="Click to Update" className="text-white bg-gradient-to-r from-green-400 via-green-500 to-green-600 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-green-300 font-medium rounded-lg text-sm px-4 py-2"><i class="fa fa-check" aria-hidden="true"></i></Button>
        //                     }
        //                 </>
        //             }
        //         </div>
        // },
        // {
        //     name: "Is Lease",
        //     cell: row =>
        //         <div>
        //             {
        //                 <>
        //                     {
        //                         !row.IsLease
        //                             ?
        //                             <Button onClick={() => fnUpdateIsLease(row.TypeId, "activate")} data-tip="Click to Update" className="text-white bg-gradient-to-r from-red-400 via-red-500 to-red-600 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm px-4 py-2"  ><i class="fa fa-times" aria-hidden="true"></i></Button>
        //                             :
        //                             <Button onClick={() => fnUpdateIsLease(row.TypeId, "deactivate")} data-tip="Click to Update" className="text-white bg-gradient-to-r from-green-400 via-green-500 to-green-600 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-green-300 font-medium rounded-lg text-sm px-4 py-2"><i class="fa fa-check" aria-hidden="true"></i></Button>
        //                     }
        //                 </>
        //             }
        //         </div>
        // },
        // {
        //     name: "Is Sell",
        //     cell: row =>
        //         <div>
        //             {
        //                 <>
        //                     {
        //                         !row.IsSell
        //                             ?
        //                             <Button onClick={() => fnUpdateIsSell(row.TypeId, "activate")} data-tip="Click to Update" className="text-white bg-gradient-to-r from-red-400 via-red-500 to-red-600 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm px-4 py-2"  ><i class="fa fa-times" aria-hidden="true"></i></Button>
        //                             :
        //                             <Button onClick={() => fnUpdateIsSell(row.TypeId, "deactivate")} data-tip="Click to Update" className="text-white bg-gradient-to-r from-green-400 via-green-500 to-green-600 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-green-300 font-medium rounded-lg text-sm px-4 py-2"><i class="fa fa-check" aria-hidden="true"></i></Button>
        //                     }
        //                 </>
        //             }
        //         </div>
        // },
        // {
        //     name: "Is Project",
        //     cell: row =>
        //         <div>
        //             {
        //                 <>
        //                     {
        //                         !row.IsProject
        //                             ?
        //                             <Button onClick={() => fnUpdateIsProject(row.TypeId, "activate")} data-tip="Click to Update" className="text-white bg-gradient-to-r from-red-400 via-red-500 to-red-600 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm px-4 py-2"  ><i class="fa fa-times" aria-hidden="true"></i></Button>
        //                             :
        //                             <Button onClick={() => fnUpdateIsProject(row.TypeId, "deactivate")} data-tip="Click to Update" className="text-white bg-gradient-to-r from-green-400 via-green-500 to-green-600 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-green-300 font-medium rounded-lg text-sm px-4 py-2"><i class="fa fa-check" aria-hidden="true"></i></Button>
        //                     }
        //                 </>
        //             }
        //         </div>
        // },
        {
            name: "Action",
            cell: row =>
                <div>
                    {
                        <>
                            {
                                !row.IsActive
                                    ?
                                    <Button onClick={() => activateDeactiveUser(row.TypeId, "activate")} data-tip="Click to Activate User" className="text-white bg-gradient-to-r from-red-400 via-red-500 to-red-600 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm px-4 py-2"  ><i class="fa fa-toggle-off" aria-hidden="true"></i></Button>
                                    :
                                    <Button onClick={() => activateDeactiveUser(row.TypeId, "deactivate")} data-tip="Click to Deactivate User" className="text-white bg-gradient-to-r from-green-400 via-green-500 to-green-600 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-green-300 font-medium rounded-lg text-sm px-4 py-2"><i class="fa fa-toggle-on" aria-hidden="true"></i></Button>
                            }
                        </>
                    }
                    <Button onClick={() => editsztypes(row.TypeId)} data-tip="Click to Edit Details" className="text-white bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-4 py-2"><i class="fa fa-pencil" aria-hidden="true"></i></Button>

                </div>
        }
    ];

    const editsztypes = async (Id) => {
        try {
            debugger;
            let items = sztype.filter(x => {
                return x.TypeId === Id;
            });

            items.map(item => {
                setTypeId(item.TypeId)
                setTypeName(item.TypeName)
                setSectionId(item.SectionId)

                setreturnId(item.TypeId)
            })

            setEdit(true)

            TypeNameInputRef.current.focus();

        }
        catch (error) {
            console.log(error);
        }
    };

    const updatesztypes = async (Id) => {
        try {

            if (TypeName.length >= 1) {
                console.warn("hdn Id : " + returnId);
                let data = { TypeId, TypeName, SectionId, ModifiedBy }
                const response = await fetch(ConcateURL + 'UpdateSZType/' + Id, {
                    method: "Post",
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${Token}`
                    },
                    body: JSON.stringify(data)
                });
                const result = await parseJSON(response);
                if (result) {
                    setreturnId(result.returnID);
                    getAllsztypes();
                    doEmptyStates();
                    enqueueSnackbar("Successfully Updated", { variant: "success" });
                }
            }
            else {
                alert("fill all the required details to update")
            }
        }
        catch (error) {
            console.log(error);
        }
    };

    const activateDeactiveUser = async (Id, Value) => {
        try {
            let data = { Value }
            const response = await fetch(ConcateURL + 'ActivateDeactivateSZType/' + Id, {
                method: "Post",
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${Token}`
                },
                body: JSON.stringify(data)
            });
            const result = await parseJSON(response);
            if (result) {
                setreturnId(result.returnID);
                getAllsztypes();
                doEmptyStates();
                Value == "activate" ?
                    enqueueSnackbar("Successfully Activated", { variant: "success" })
                    :
                    enqueueSnackbar("Successfully Deactivated", { variant: "success" });
            }
        }
        catch (error) {
            console.log(error);
        }
    };

    const fnUpdateIsResidential = async (Id, Value) => {
        try {
            let data = { Value }
            const response = await fetch(ConcateURL + 'UpdateIsResidential/' + Id, {
                method: "Post",
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${Token}`
                },
                body: JSON.stringify(data)
            });
            const result = await parseJSON(response);
            if (result) {
                setreturnId(result.returnID);
                getAllsztypes();
                doEmptyStates();
                enqueueSnackbar("Successfully Updated", { variant: "success" })
            }
        }
        catch (error) {
            console.log(error);
        }
    };


    const fnUpdateIsCommercial = async (Id, Value) => {
        try {
            let data = { Value }
            const response = await fetch(ConcateURL + 'UpdateIsCommercial/' + Id, {
                method: "Post",
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${Token}`
                },
                body: JSON.stringify(data)
            });
            const result = await parseJSON(response);
            if (result) {
                setreturnId(result.returnID);
                getAllsztypes();
                doEmptyStates();
                enqueueSnackbar("Successfully Updated", { variant: "success" })
            }
        }
        catch (error) {
            console.log(error);
        }
    };

    const fnUpdateIsLease = async (Id, Value) => {
        try {
            let data = { Value }
            const response = await fetch(ConcateURL + 'UpdateIsLease/' + Id, {
                method: "Post",
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${Token}`
                },
                body: JSON.stringify(data)
            });
            const result = await parseJSON(response);
            if (result) {
                setreturnId(result.returnID);
                getAllsztypes();
                doEmptyStates();
                enqueueSnackbar("Successfully Updated", { variant: "success" })
            }
        }
        catch (error) {
            console.log(error);
        }
    };

    const fnUpdateIsSell = async (Id, Value) => {
        try {
            let data = { Value }
            const response = await fetch(ConcateURL + 'UpdateIsSell/' + Id, {
                method: "Post",
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${Token}`
                },
                body: JSON.stringify(data)
            });
            const result = await parseJSON(response);
            if (result) {
                setreturnId(result.returnID);
                getAllsztypes();
                doEmptyStates();
                enqueueSnackbar("Successfully Updated", { variant: "success" })
            }
        }
        catch (error) {
            console.log(error);
        }
    };

    const fnUpdateIsProject = async (Id, Value) => {
        try {
            let data = { Value }
            const response = await fetch(ConcateURL + 'UpdateIsProject/' + Id, {
                method: "Post",
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${Token}`
                },
                body: JSON.stringify(data)
            });
            const result = await parseJSON(response);
            if (result) {
                setreturnId(result.returnID);
                getAllsztypes();
                doEmptyStates();
                enqueueSnackbar("Successfully Updated", { variant: "success" })
            }
        }
        catch (error) {
            console.log(error);
        }
    };


    useEffect(() => {
        const result = sztype.filter(x => {
            return x.TypeName.toLowerCase().match(search.toLowerCase())
                || x.SectionName.toLowerCase().match(search.toLowerCase());

        })
        setfiltersztype(result);
    }, [search]);

    useEffect(() => {
        if (SectionId == 0 || SectionId == "0") {
            setfiltersztype(sztype);
        }
        else {
            const result = sztype.filter(x => x.SectionId == SectionId)
            setfiltersztype(result);
        }

    }, [SectionId])

    const tableData = { coloumn, filtersztype };


    return (
        <div>
            <Layout>
                <main className="flex-1 overflow-y-auto p-4 sm:p-6 lg:p-8">
                    <div className="space-y-6">
                        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
                            <h2 className="text-xl font-semibold text-gray-900 mb-6">
                                Add Property Type
                            </h2>

                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                <div>
                                    <label htmlFor="role" className="block text-sm font-medium text-gray-700 mb-2">
                                        Choose Category
                                    </label>
                                    <select
                                        id="role"
                                        name="role"
                                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors duration-200"
                                        onChange={(e) => setSectionId(e.target.value)}
                                        value={SectionId}
                                    >
                                        <option value="0" selected>Select</option>
                                        {
                                            zsection && zsection !== undefined
                                                ?
                                                zsection.map((dis, index) => {
                                                    return (
                                                        <option value={dis.SectionId} >{dis.SectionName}</option>
                                                    )
                                                })
                                                :
                                                null
                                        }
                                    </select>
                                </div>

                                <div>
                                    <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-2">
                                        Property Type
                                    </label>
                                    <input
                                        type="text"
                                        id="name"
                                        ref={TypeNameInputRef}
                                        value={TypeName}
                                        onChange={(e) => { setTypeName(e.target.value) }}
                                        placeholder="Enter Type Name"
                                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors duration-200"
                                    />
                                </div>
                            </div>

                            <div className="flex flex-col sm:flex-row gap-4 mt-3">
                                {
                                    edit == false ?
                                        <Button
                                            className="px-6 py-3 bg-indigo-600 text-white font-medium rounded-lg hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 transition-colors duration-200 flex items-center justify-center space-x-2"
                                            onClick={() => insertsztypes()}
                                        >
                                            <span>Add</span>
                                        </Button> :
                                        <Button
                                            className="px-6 py-3 bg-indigo-600 text-white font-medium rounded-lg hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 transition-colors duration-200 flex items-center justify-center space-x-2"
                                            onClick={() => updatesztypes(returnId)}
                                        >
                                            <span>Update</span>
                                        </Button>
                                }

                                <button
                                    type="button"
                                    onClick={() => doEmptyStates()}
                                    className="px-6 py-3 bg-gray-600 text-white font-medium rounded-lg hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 transition-colors duration-200"
                                >
                                    Reset
                                </button>

                            </div>
                        </div>


                        <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">



                            <div class="overflow-x-auto">
                                <DataTable
                                    title="Manage Property Types"
                                    columns={coloumn}
                                    data={filtersztype}
                                    pagination
                                    fixedHeader
                                    fixedHeaderScrollHeight="550px"
                                    selectableRows
                                    selectableRowsHighlight
                                    highlightOnHover
                                    // actions={<button className="btn btn-sm btn-info">Export</button>}                                                
                                    subHeader
                                    subHeaderAlign="right"
                                    subHeaderComponent={
                                        <input type="text"
                                            placeholder="search username"
                                            className="w-full sm:w-64 px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                                            value={search}
                                            onChange={(e) => setsearch(e.target.value)}
                                        />
                                    }
                                />
                            </div>
                        </div>
                    </div>


                </main>
            </Layout >

        </div >
    )
}

export default CreateProperty